import { css, styled } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { Flex } from './Flex.js';
import { cssTextEllipsis } from '../constants/styled-utils.js';
import { preventForwardPropsConfig } from '../utils/preventForwardProps.js';

const color = {
  primary: cssVar["color-text-primary"],
  secondary: cssVar["color-text-secondary"],
  tertiary: cssVar["color-text-tertiary"],
  quaternary: cssVar["color-text-quaternary"],
  placeholder: cssVar["color-text-placeholder"],
  darkblue: cssVar["color-text-darkblue"],
  inherit: "inherit",
  ["app-secondary"]: `rgba(${cssVar["color-app-secondary-rgb"]}, 0.6)`,
  ["app-primary"]: cssVar["color-app-primary-text"],
  delete: cssVar["color-app-delete"]
};
const cssFontSizeProperties = css([
  ``,
  ``
], (p) => {
  switch (p.size) {
    case "xxs":
      return css([
        `font-size:0.75rem;line-height:0.875rem;`
      ]);
    case "xs":
      return css([
        `font-size:0.8125rem;line-height:1.125rem;`
      ]);
    case "sm":
      return css([
        `font-size:0.875rem;line-height:1.25rem;`
      ]);
    case "sm-plus":
      return css([
        `font-size:0.9rem;line-height:1.1875rem;`
      ]);
    case "md":
      return css([
        `font-size:0.9375rem;line-height:1.25rem;`
      ]);
    case "lg":
      return css([
        `font-size:1rem;line-height:1.5rem;`
      ]);
    case "xl":
      return css([
        `font-size:1.125rem;line-height:1.5rem;`
      ]);
  }
});
const P = styled.p.withConfig(preventForwardPropsConfig([
  "ellipsis",
  "tt",
  "wordBreak",
  "userSelect",
  "weight",
  "size",
  "hasHoverState"
])).withConfig({
  displayName: "Typography__P",
  componentId: "sc-b836ef1d-0"
})([
  ``,
  ` `,
  ` font-weight:`,
  `;`,
  ` `,
  ` `,
  ` `,
  ``
], (p) => `color: ${color[p.color || "primary"]};`, cssFontSizeProperties, ({ weight }) => weight || 400, (p) => p.ellipsis && cssTextEllipsis, (p) => p.tt && css([
  `text-transform:`,
  `;`
], p.tt), (p) => p.wordBreak && css([
  `word-break:`,
  `;`
], p.wordBreak), (p) => p.userSelect && css([
  `user-select:`,
  `;`
], p.userSelect));
const SPAN = styled(P).attrs((props) => {
  return {
    as: "span",
    ...props
  };
}).withConfig({
  displayName: "Typography__SPAN",
  componentId: "sc-b836ef1d-1"
})([
  ``
]);
const TypographyContainer = styled(Flex).attrs((props) => {
  return {
    direction: "column",
    gap: "text",
    // spread the given props or the we are unable to override the default props
    ...props
  };
}).withConfig({
  displayName: "Typography__TypographyContainer",
  componentId: "sc-b836ef1d-2"
})([
  ``
]);
const SectionTitle = styled(P).attrs({
  color: "secondary"
}).withConfig({
  displayName: "Typography__SectionTitle",
  componentId: "sc-b836ef1d-3"
})([
  `display:block;font-weight:500;`
]);
const H1 = styled.div.withConfig({
  displayName: "Typography__H1",
  componentId: "sc-b836ef1d-4"
})([
  `font-weight:700;font-size:1.625rem;line-height:2.25rem;color:`,
  `;`
], (p) => color[p.color || "primary"]);
const H2 = styled.div.withConfig({
  displayName: "Typography__H2",
  componentId: "sc-b836ef1d-5"
})([
  `font-weight:600;font-size:1.5rem;line-height:2rem;color:`,
  `;`
], (p) => color[p.color || "primary"]);
const UL = styled.ul.withConfig({
  displayName: "Typography__UL",
  componentId: "sc-b836ef1d-6"
})([
  `list-style-type:disc;padding-left:20px;color:`,
  `;`
], cssVar["color-text-secondary"]);
const LI = styled.li.withConfig({
  displayName: "Typography__LI",
  componentId: "sc-b836ef1d-7"
})([
  `font-size:15px;font-weight:400;gap:4px;`
]);
const A = styled.a.withConfig({
  displayName: "Typography__A",
  componentId: "sc-b836ef1d-8"
})([
  ``,
  ` text-decoration:underline;cursor:pointer;`
], (p) => `color: ${color[p.color || "primary"]};`);
const DL = styled.dl.withConfig({
  displayName: "Typography__DL",
  componentId: "sc-b836ef1d-9"
})([
  `display:flex;flex-direction:column;gap:1rem;margin:0;padding:0;`
]);
const DLItem = styled.div.withConfig({
  displayName: "Typography__DLItem",
  componentId: "sc-b836ef1d-10"
})([
  `display:flex;flex-direction:column;gap:2px;`
]);
const DT = styled.dt.withConfig({
  displayName: "Typography__DT",
  componentId: "sc-b836ef1d-11"
})([
  ``,
  ` `,
  ` font-weight:`,
  `;text-align:left;&::after{content:':';}`
], (p) => `color: ${color[p.color || "quaternary"]};`, cssFontSizeProperties, ({ weight }) => weight || 600);
const DD = styled.dd.withConfig({
  displayName: "Typography__DD",
  componentId: "sc-b836ef1d-12"
})([
  ``,
  ` `,
  ` font-weight:`,
  `;margin:0;white-space:break-spaces;word-break:break-word;`
], (p) => `color: ${color[p.color || "primary"]};`, cssFontSizeProperties, ({ weight }) => weight || 400);

export { A, DD, DL, DLItem, DT, H1, H2, LI, P, SPAN, SectionTitle, TypographyContainer, UL };
//# sourceMappingURL=Typography.js.map
